// A new purpose/notice requires a fresh choice rather than reusing legacy GTM consent.
const CONSENT_STORAGE_KEY = 'olgun_consent_v2';
const CONSENT_UPDATED_EVENT = 'olgun-consent-updated';
let transientConsent = null;

const deniedConsent = {
  analytics_storage: 'denied',
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied'
};

function ensureDataLayer() {
  if (typeof window === 'undefined') {
    return null;
  }

  window.dataLayer = window.dataLayer || [];
  return window.dataLayer;
}

function sendGtagCommand() {
  const dataLayer = ensureDataLayer();
  if (!dataLayer) {
    return;
  }

  dataLayer.push(arguments);
}

export function readConsentChoice() {
  if (typeof window === 'undefined') {
    return null;
  }

  if (transientConsent) {
    return transientConsent;
  }

  try {
    const stored = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    const choice = stored ? JSON.parse(stored) : null;
    if (!choice || typeof choice !== 'object' || Array.isArray(choice) ||
        Object.keys(deniedConsent).some(key => !['granted', 'denied'].includes(choice[key]))) return null;
    return choice;
  } catch {
    return null;
  }
}

export function initializeConsent() {
  const choice = readConsentChoice();
  const state = choice || deniedConsent;

  sendGtagCommand('consent', 'default', {
    ...state,
    wait_for_update: 500
  });
  sendGtagCommand('set', 'ads_data_redaction', true);
  sendGtagCommand('set', 'url_passthrough', false);

  return choice;
}

export function updateConsent({ analytics, advertising }) {
  const state = {
    analytics_storage: analytics ? 'granted' : 'denied',
    ad_storage: advertising ? 'granted' : 'denied',
    ad_user_data: advertising ? 'granted' : 'denied',
    // The advertised choice covers conversion measurement, not personalized ads.
    ad_personalization: 'denied'
  };

  try {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(state));
    window.localStorage.removeItem('olgun_consent_v1');
    transientConsent = null;
  } catch {
    transientConsent = state;
    // Consent still applies for the current page when storage is unavailable.
  }

  sendGtagCommand('consent', 'update', state);
  pushDataLayer('consent_update', {
    analytics_consent: state.analytics_storage,
    advertising_consent: state.ad_storage
  });
  window.dispatchEvent(new Event(CONSENT_UPDATED_EVENT));
}

export function pushDataLayer(event, parameters = {}) {
  const dataLayer = ensureDataLayer();
  if (!dataLayer) {
    return;
  }

  dataLayer.push({ event, ...parameters });
}

export { CONSENT_STORAGE_KEY, CONSENT_UPDATED_EVENT, deniedConsent };
